import { render } from "./form_wizard.vue?vue&type=template&id=7672c5d2"
import script from "./form_wizard.vue?vue&type=script&lang=js"
export * from "./form_wizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__